export const environment = {
    API_URL: 'https://admin.krisalee.fr/api',
    KC_URL: 'https://auth.admin.krisalee.fr/',
    KC_REALM: 'master',
    KC_CLIENT_ID: 'krisalee-frontend',
    DIR: '/usr/src/app',
    NEXTCLOUD_URL: 'undefined',
    SITE_INTERNE_URL: 'undefined',
    SITE_EXTERNE_URL: 'undefined',
    KEYCLOAK_URL: 'undefined',
    MAILSERVER_URL: 'undefined',
    CHAT_URL: 'undefined',
   production: 'true',
   ORGANIZATION_ID: 'undefined',
   ORGANIZATION_ADMIN_ID: 'undefined',
   PROD_TAG_ID: 'prod_1690553289436',
   alertUserId:'alert user',
   SEARCH_COLUMNS:['firstName', 'lastName', 'username', 'email'],
   ADMIN_APITECH_EMAIL:'sysadmin@apitech.fr',
   IMPORT_LDAP_ID:'import ldap',
   K8S_PROVIDERS_LIST: ['ovh','apitech'],
};
